import Vue from 'vue'

import 'normalize.css/normalize.css'

import ElementUI from 'element-ui'
import { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.less'

import App from './App.vue'
import router from './router'
import store from './store'

import api from '@/api'
import '@/icons'

import { baseURL } from '@/utils/config.js'
Vue.prototype.$baseURL = baseURL

import { setCache, getCache, clearCache } from '@/utils/cache.js'
Vue.prototype.$setCache = setCache
Vue.prototype.$getCache = getCache
Vue.prototype.$clearCache = clearCache

import moment from 'moment'
Vue.prototype.$moment = moment
moment.locale('zh-cn')
Vue.prototype.goTo = function (to, options = {}) {
  if (!to) {
    Message({
      message: '当前用户无权限',
      type: 'error',
      duration: 3000
    })
    return
  }
  const { replace = false, query = {}, params = {} } = options
  const route = typeof to === 'string' ? { path: to } : to
  // 合并参数
  if (Object.keys(query).length) route.query = { ...route.query, ...query }
  if (Object.keys(params).length) route.params = { ...route.params, ...params }
  if (replace) {
    this.$router.replace(route)
  } else {
    this.$router.push(route)
  }
}
Vue.use(ElementUI, { size: 'small' })

Vue.prototype.$api = api
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
